(() => {
  const marker=document.querySelector('[data-sm-product-polish]');
  if(!marker)return;
  const element=(tag,className,text)=>{const el=document.createElement(tag);if(className)el.className=className;if(text)el.textContent=text;return el;};
  const readReview=source=>({
    author:source.querySelector('.vtl-pr-ri__user-name')?.textContent.trim(),
    message:source.querySelector('.vtl-pr-ri__message')?.textContent.trim(),
    stars:source.querySelector('.vtl-pr-ri__stars [role="img"]'),
    image:source.querySelector('.vtl-pr-ri__images img'),
    verification:source.querySelector('.vtl-pr-ri__uv-text')?.textContent.trim()
  });
  const starsFor=review=>{if(!review.stars)return null;const stars=review.stars.cloneNode(true);stars.classList.add('sm-proof-stars');return stars;};
  const imageFor=(review,className)=>{if(!review.image)return null;const img=element('img',className);img.src=review.image.currentSrc||review.image.src;img.alt=review.author||'';img.loading='lazy';img.width=270;img.height=180;return img;};
  const copyFor=review=>{
    const copy=element('div','sm-story__proofcopy');const stars=starsFor(review);if(stars)copy.append(stars);
    copy.append(element('blockquote','',review.message));
    const caption=element('figcaption');caption.append(element('strong','',review.author));
    if(review.verification)caption.append(element('small','',review.verification));copy.append(caption);return copy;
  };
  const fillProof=widget=>{
    const reviews=[...widget.querySelectorAll('.vtl-pr-ri__wrapper')].map(readReview).filter(x=>x.author&&x.message);
    if(!reviews.length)return;
    document.querySelectorAll('[data-sm-top-review]:not([data-filled])').forEach(top=>{
      const review=reviews[0],card=top.querySelector('[data-sm-top-review-card]'),picture=imageFor(review,'');
      if(picture){picture.width=76;picture.height=76;card.append(picture);}
      const copy=element('div');copy.append(element('blockquote','',review.message),element('p','',review.author));const stars=starsFor(review);if(stars)copy.append(stars);
      card.append(copy);top.dataset.filled='true';top.hidden=false;
    });
    document.querySelectorAll('[data-sm-social-fill]').forEach(social=>{
      const rail=social.querySelector('[data-sm-proof-rail]');
      if(!rail)return;
      const normalize=value=>(value||'').normalize('NFKC').toLowerCase().replace(/[\s“”"'‘’.,!?—–-]+/g,'');
      const cards=[...rail.querySelectorAll('.sm-story__proofcard')];
      const existing=new Set(cards.map(card=>normalize(card.querySelector('figcaption strong')?.textContent)+'|'+normalize(card.querySelector('blockquote')?.textContent)));
      let count=cards.length;
      for(const review of reviews){
        if(count>=6)break;
        const key=normalize(review.author)+'|'+normalize(review.message);
        if(existing.has(key))continue;
        const card=element('figure','sm-story__proofcard');
        const picture=imageFor(review,'sm-story__proofimage');
        if(picture)card.append(picture);
        card.append(copyFor(review));rail.append(card);existing.add(key);count++;
      }
      if(count)social.hidden=false;
    });
  };
  const compactQuotes=()=>document.querySelectorAll('.sm-story__proofcard blockquote,.sm-nap-quote blockquote').forEach(quote=>{
    if(quote.dataset.compactReady)return;quote.dataset.compactReady='true';
    if(quote.textContent.trim().length<240)return;
    quote.classList.add('sm-proof-excerpt');
    const button=element('button','sm-proof-toggle',marker.dataset.readReview);button.type='button';button.setAttribute('aria-expanded','false');
    button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(expanded));quote.classList.toggle('sm-proof-excerpt',!expanded);button.textContent=expanded?marker.dataset.lessReview:marker.dataset.readReview;});
    quote.after(button);
  });
  const enhance=()=>{
    document.querySelectorAll('.product__info-container').forEach(root=>{
      const target=root.querySelector('.sm-trust-badges [data-catalog-rating]');
      const rating=root.querySelector('.vtl-pr__product-title-star-snippets');
      if(target&&rating&&rating.parentElement!==target)target.append(rating);
    });
    document.querySelectorAll('.vtl-pr-main-widget--product-page').forEach(widget=>{
      const host=document.querySelector('[data-catalog-live-reviews]');
      if(host&&widget.querySelector('.vtl-pr-totals')){
        if(widget.parentElement!==host)host.append(widget);
        const section=host.closest('.sm-story');if(section)section.hidden=false;
        const staticReviews=section?.querySelector('.sm-story__reviews');if(staticReviews)staticReviews.hidden=true;
      }
      if(document.querySelector('.sm-story__reviewhead'))document.querySelectorAll('.sm-review-heading').forEach(heading=>heading.remove());
      if(!document.querySelector('.sm-story__reviewhead')&&!widget.previousElementSibling?.matches('.sm-review-heading')){
        const heading=document.createElement('h2');heading.className='sm-review-heading';heading.textContent=marker.dataset.reviewHeading;widget.before(heading);
      }
      fillProof(widget);
    });
    compactQuotes();
  };
  enhance();let scheduled=false;
  new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;enhance();});}).observe(document.body,{childList:true,subtree:true});
})();

